import { useEffect, useState } from "react";
import { Center, CheckIcon, Container, Stack, Text, Title, Transition } from "@mantine/core";
import { useTranslation } from "react-i18next";
import OauthRenderer from "@pages/oauth/OauthRender";

export const basePath = import.meta.env.BASE_URL;
const PaymentComplete: React.FC = () => {
	const [visible, setVisible] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		setTimeout(() => setVisible(true), 1);
	}, []);

	return (
		<Container size="xs" my={50}>
			<Center>
				<Stack align="center">
					<Transition
						mounted={visible}
						transition={{
							in: { opacity: 1, transform: "scale(1)" },
							out: { opacity: 0, transform: "scale(2)" },
							common: { transformOrigin: "center" },
							transitionProperty: "transform, opacity"
						}}
						duration={500}
						timingFunction="ease-in-out"
					>
						{(styles) => (
							<div style={{ ...styles, display: "inline", position: "fixed", width: 100, height: 100 }}>
								<div
									style={{
										border: "4px solid #4caf50",
										borderRadius: "50%",
										width: "100%",
										height: "100%",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										backgroundColor: "#4caf50"
									}}
								></div>
							</div>
						)}
					</Transition>
					<Transition
						mounted={visible}
						transition={{
							in: { opacity: 1, transform: "scaleY(1) rotate(0deg)" },
							out: { opacity: 0, transform: "scaleY(0) rotate(-180deg)" },
							common: { transformOrigin: "center" },
							transitionProperty: "transform, opacity"
						}}
						duration={500}
						timingFunction="ease-in-out"
					>
						{(styles) => (
							<div
								style={{
									...styles,
									display: "inline",
									position: "fixed",
									paddingLeft: 20,
									paddingTop: 20,
									width: 100,
									height: 100
								}}
							>
								<CheckIcon size={60} color="white" />
							</div>
						)}
					</Transition>

					<Title mt={120} order={2}>
						{t("common.paymentComplete", "Payment complete!")}
					</Title>

					<Text>{t("common.thankYouForPayment", "Thank you for your payment")}</Text>

					<OauthRenderer refreshToken={"payment"} error={null} />
					<Text c="dimmed">{t("common.weWillDeliverItShortly", "We will deliver it shortly!")}</Text>
				</Stack>
			</Center>
		</Container>
	);
};
export default PaymentComplete;
